import { ICONS } from '../constants';

const SocialMedia = [
	{
		title: 'Twitter',
		url: 'https://twitter.com/thelamina_',
		icon: ICONS.twitter,
	},
	{
		title: 'GitHub',
		url: 'https://www.github.com/thelamina',
		icon: ICONS.github,
	},
	{
		title: 'LinkedIn',
		url: 'https://www.linkedin.com/in/thelamina',
		icon: ICONS.linkedin,
	},
];

export default SocialMedia;
